<google-map
    height="100vh"
    width="100vw"
    [options]="options"
    class="zoom-{{actualZoom}}"
    [center]="center"
    [zoom]="setZoom"
    #googleMap>
</google-map>
